import { render, staticRenderFns } from "./IconSvgHearth.vue?vue&type=template&id=f712fc22&scoped=true&"
import script from "./IconSvgHearth.vue?vue&type=script&lang=js&"
export * from "./IconSvgHearth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f712fc22",
  null
  
)

export default component.exports